<template>
<div class="designtool">
  <div class="tools mt-3">
    <b-button-group class="m-1">
      <b-button @click="zoom(-0.1)"  :disabled="!designPresent">
        <b-iconstack font-scale="1">
          <b-icon-search stacked></b-icon-search>
          <b-icon-dash stacked scale="0.80" shift-v="1.25" shift-h="-1.25"></b-icon-dash>
        </b-iconstack>
        <span class="zoomtext">x10</span>
      </b-button>
      <b-button @click="zoom(-0.01)" :disabled="!designPresent">
        <b-iconstack font-scale="0.99">
          <b-icon-search stacked></b-icon-search>
          <b-icon-dash stacked scale="0.80" shift-v="1.25" shift-h="-1.25"></b-icon-dash>
        </b-iconstack>
      </b-button>
      <b-button @click="zoomNormal"  :disabled="!designPresent">
        <!-- <b-icon-search aria-hidden="true"></b-icon-search> -->
        Zoom: Fit
      </b-button>
      <b-button @click="zoom(0.01)" :disabled="!designPresent">
        <b-iconstack font-scale="0.99">
          <b-icon-search stacked></b-icon-search>
          <b-icon-plus stacked scale="0.80" shift-v="1.25" shift-h="-1.25"></b-icon-plus>
        </b-iconstack>
      </b-button>
      <b-button @click="zoom(0.1)"  :disabled="!designPresent">
        <b-iconstack font-scale="1">
          <b-icon-search stacked></b-icon-search>
          <b-icon-plus stacked scale="0.80" shift-v="1.25" shift-h="-1.25"></b-icon-plus>
        </b-iconstack>
        <span class="zoomtext">x10</span>
      </b-button>
    </b-button-group>
    <b-button @click="center" :disabled="!designPresent"  class="m-1">
      <b-icon-arrows-move aria-hidden="true"></b-icon-arrows-move>
      Center
    </b-button>
  </div>

  <div class="designcanvas">
    <DesignView
        :design="design"
        :toolimages="product.toolimages"
        ref="designview"
    ></DesignView>
    <img id="tool-overlay" class="capimg"
        v-if="product.toolimages.overlay && guideVisible"
        :src="product.toolimages.overlay"
        alt="" />
    <VueDragResize
        v-if="design.image.key"
        ref="resizer"
        :w="400"
        :h="400"
        :isActive="true"
        :aspectRatio="lockAspectRatio"
        :parentLimitation="false"
        :sticks="['tl','tr','bl','br']"
        v-on:resizing="handleResizeEvent"
        v-on:dragging="handleResizeEvent">
      <img id="cap-img-handle" class="movable"
          :src="product.toolimages.transparent"
          alt="" />
    </VueDragResize>

    <div class="cap-overlay" v-if="!designPresent" >
      <ImageSelect v-on:newImage="newImage" />
    </div>
  </div>

</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import VueDragResize from 'vue-drag-resize';
import {
  BIconstack, BIconSearch, BIconPlus, BIconDash, BIconArrowsMove,
} from 'bootstrap-vue';

import DesignView from '@/components/DesignView.vue';
import ImageSelect from '@/components/ImageSelect.vue';

export default {
  name: 'DesignCanvas',
  components: {
    DesignView,
    ImageSelect,
    VueDragResize,
    BIconstack,
    BIconSearch,
    BIconPlus,
    BIconDash,
    BIconArrowsMove,
  },
  props: {
  },
  data() {
    return {
      imagesLoaded: false,
      lockAspectRatio: true,
    };
  },
  computed: {
    designPresent() {
      return !!this.design.image && !!this.design.image.key;
    },
    ...mapState(['product', 'guideVisible']),
    ...mapGetters(['design']),
  },
  // mounted() {
  // },
  // beforeUpdate() {
  //   this.imagesLoaded = false;
  // },
  // updated() {
  //   this.checkImageLoad();
  // },
  methods: {
    handleResizeEvent(newRect) {
      // console.log('handleResizeEvent', newRect);
      const newRelativePosition = this.$refs.designview.relativeFromBox(newRect);
      // console.log('resized to:', newRelativePosition);
      const designparams = { relativePosition: newRelativePosition };
      this.$store.commit('setDesign', designparams);
    },
    directResize(rect) {
      /* Resize the vue-drag-resize object, which is our principle source for size,
      * and trigger a resize event as it does when resized via UI.
      * This is a bit intrusive, but we have no choice but to manipulate its guts,
      * since it doesn't provide for programmatic resize.
      */
      const { resizer } = this.$refs;
      console.log('directResize:', rect);
      console.log('resizer existing:', {
        top: resizer.top,
        bottom: resizer.bottom,
        left: resizer.left,
        right: resizer.right,
      });

      // Turn off aspect ratio protection for all direct resize. Since we change
      // the size handles one-by-one, it'll be out-of-size in the middle of the
      // process and screw up the x/y by the end.
      const existingLockAspectRatio = this.lockAspectRatio;
      this.lockAspectRatio = false;

      if (rect.top) {
        resizer.top = rect.top;
      }
      if (rect.height) {
        const newBottom = resizer.parentHeight - resizer.top - rect.height;
        resizer.bottom = newBottom;
      }

      if (rect.left) {
        resizer.left = rect.left;
      }
      if (rect.width) {
        const newRight = resizer.parentWidth - resizer.left - rect.width;
        resizer.right = newRight;
      }
      //
      this.$nextTick(() => {
        this.handleResizeEvent({
          top: this.$refs.resizer.top,
          left: this.$refs.resizer.left,
          width: this.$refs.resizer.width,
          height: this.$refs.resizer.height,
        });
        // restore aspect ratio control after we're done
        this.lockAspectRatio = existingLockAspectRatio;
      });
    },
    zoomNormal() {
      // do a 'cover' on the image; zoom its smallest dimension to visible
      console.log('zoomNormal ...');
      // because relativeX is based on relativeWidth, due to square-based assumptions,
      // we need to do some extra handling when snapping to height, thus sizeClamp
      // const baseAspectRatio = 1.214285714;
      const baseAspectRatio = this.product.toolimages.aspectratio || 1;
      console.log('product aspectRatio', baseAspectRatio);
      const sizeClamp = 1 / baseAspectRatio;

      const imageAspectRatio = this.$refs.designview.imageAspectRatio();
      // aspectRatio = naturalWidth / naturalHeight
      console.log('image aspectRatio:', imageAspectRatio);
      let relativeWidth = 1;
      let relativeHeight = 1;

      if (imageAspectRatio >= baseAspectRatio) {
        // wider than tall (or exact)
        console.log('wide image');
        relativeWidth = imageAspectRatio;

        relativeWidth *= sizeClamp;
        relativeHeight *= sizeClamp;
      } else if (imageAspectRatio < baseAspectRatio) {
        // taller than wide
        console.log('tall image');
        relativeHeight = 1 / imageAspectRatio;
      }

      console.log('relativeWidth:', relativeWidth, 'relativeHeight:', relativeHeight);

      const newBox = this.$refs.designview.boxFromRelative({
        centerX: this.design.relativePosition.centerX,
        centerY: this.design.relativePosition.centerY,
        width: relativeWidth,
        height: relativeHeight,
      });

      console.log('zooming to:', newBox);
      this.directResize(newBox);
    },
    zoom(amount) {
      console.log('zoom...', amount);
      const multiplier = 1 + amount;

      const newBox = this.$refs.designview.boxFromRelative({
        centerX: this.design.relativePosition.centerX,
        centerY: this.design.relativePosition.centerY,
        width: this.design.relativePosition.width * multiplier,
        height: this.design.relativePosition.height * multiplier,
      });

      console.log('zooming to:', newBox);
      this.directResize(newBox);
    },
    center() {
      console.log('center...');
      const newBox = this.$refs.designview.boxFromRelative({
        centerX: 0,
        centerY: 0,
        width: this.design.relativePosition.width,
        height: this.design.relativePosition.height,
      });
      console.log('moving to:', newBox);
      this.directResize(newBox);
    },
    newImage() {
      console.log('newImage');
      this.$nextTick(() => { // resizer doens't exist until image is present
        this.zoomNormal(); // fix aspect ratio for new images
        // centering is handled by resetting relative design center to 0/0
      });
    },
    designLoaded() {
      console.log('designLoaded', this);
      // design updated underneath us, so update drag handle
      const newBox = this.$refs.designview.boxFromRelative({
        centerX: this.design.relativePosition.centerX,
        centerY: this.design.relativePosition.centerY,
        width: this.design.relativePosition.width,
        height: this.design.relativePosition.height,
      });
      console.log('to:', newBox);
      this.$nextTick(() => { // resizer doens't exist until image is present
        this.directResize(newBox);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.designcanvas {
  position: relative;
  top:0;
  left:0;
  width: 96%;
  max-width:400px;
  height: 400px;  /* TODO: set dynamically */
  overflow: hidden;
}

.designcanvas img {
  position:absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.designcanvas .cap-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
}

.zoomtext {
  font-size: small;
  padding-left: 0.3em;
}
</style>
